import React, { ReactNode } from 'react';
import { PageShell } from './PageShell';
import { StatusIcon, StatusIconVariant } from './StatusIcon';

export interface StatusPageLayoutProps {
  variant: StatusIconVariant;
  title: string;
  body?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  showFooter?: boolean;
  className?: string;
}

export function StatusPageLayout({
  variant,
  title,
  body,
  children,
  actions,
  showFooter = false,
  className = '',
}: StatusPageLayoutProps) {
  return (
    <PageShell showFooter={showFooter} className={`ev-status-page ${className}`.trim()}>
      <div className="ev-status-main">
        <div className="ev-status-card ev-animate-in">
          <StatusIcon variant={variant} />
          <h1 className="ev-status-title">{title}</h1>
          {body && <p className="ev-status-body">{body}</p>}
          {children}
        </div>
        {actions && <div className="ev-status-actions ev-animate-in">{actions}</div>}
      </div>
    </PageShell>
  );
}

export default StatusPageLayout;
